import PropTypes from 'prop-types';
import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './Calendar.css';
import DateCell from './DateCell';
import EventsHelper from '../../../lib/utils/events';
import moment from 'moment-timezone';

export default class AvailabilityCalendar extends React.Component {
  static propTypes = {
    toggleAvailabilityView: PropTypes.func,
    selectedDay: PropTypes.object.isRequired,
    updateSelectedDay: PropTypes.func.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    closeOnSelect: PropTypes.bool,
    close: PropTypes.func,
    openAvailabilityDetails: PropTypes.func,
    showDetails: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      visibleMonth: this.props.selectedDay || new Date(),
      eventsByDate: {}
    };
    this.isTentative = this.isTentative.bind(this);
    this.isBooked = this.isBooked.bind(this);
    this.isCanceled = this.isCanceled.bind(this);
    this.renderDay = this.renderDay.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.selectDay = this.selectDay.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentWillMount() {
    const timeZone = this.getTimeZone();
    this.props.relay.refetch(fragmentVariables =>
      Object.assign({}, fragmentVariables, {
        afterTime: moment
          .tz(this.state.visibleMonth, timeZone)
          .startOf('month')
          .subtract(1, 'month')
          .toISOString(),
        beforeTime: moment
          .tz(this.state.visibleMonth, timeZone)
          .startOf('month')
          .add(1, 'month')
          .toISOString(),
        returnEmptyConnection: false
      })
    );
    const userEvents = this.props.viewer
      ? this.props.viewer.AvailabilityCalendarContainer_user_events.edges
      : [];
    this.setState({
      eventsByDate: EventsHelper.groupEventsByDate(
        userEvents,
        this.state.visibleMonth,
        this.getTimeZone()
      )
    });
  }

  componentWillReceiveProps(nextProps) {
    const userEvents = nextProps.viewer
      ? nextProps.viewer.AvailabilityCalendarContainer_user_events.edges
      : [];
    this.setState({
      eventsByDate: EventsHelper.groupEventsByDate(
        userEvents,
        this.state.visibleMonth,
        this.getTimeZone()
      )
    });
  }

  onBlur(e) {
    if (e.relatedTarget && !e.relatedTarget.className.match('DayPicker')) {
      if (this.props.close) this.props.close(e);
    }
  }

  onMonthChange(month) {
    const timeZone = this.getTimeZone();
    this.props.relay.refetch(fragmentVariables =>
      Object.assign({}, fragmentVariables, {
        afterTime: moment
          .tz(month, timeZone)
          .startOf('month')
          .subtract(1, month)
          .toISOString(),
        beforeTime: moment
          .tz(month, timeZone)
          .startOf('month')
          .add(1, 'month')
          .toISOString(),
        returnEmptyConnection: false
      })
    );
    const userEvents = this.props.viewer
      ? this.props.viewer.AvailabilityCalendarContainer_user_events.edges
      : [];
    this.setState({
      visibleMonth: month,
      eventsByDate: EventsHelper.groupEventsByDate(
        userEvents,
        month,
        this.getTimeZone()
      )
    });
  }

  getTimeZone() {
    return (
      (this.props.viewer && this.props.viewer.s_time_zone) || moment.tz.guess()
    );
  }

  selectDay() {
    this.props.updateSelectedDay(this.props.selectedDay);
    this.props.openAvailabilityDetails();
  }

  handleDayClick(day) {
    this.props.updateSelectedDay(day);
    if (this.props.closeOnSelect) this.props.close();
  }

  isBooked(day) {
    let isBooked = false;
    const eventsByDate = this.state.eventsByDate[day.getDate()];
    for (let i = 0; i < eventsByDate.length; i++) {
      if (eventsByDate[i].node.booking_status === 'BOOKED') {
        isBooked = true;
      }
    }
    return isBooked;
  }

  isTentative(day) {
    let isTentative = false;
    const eventsByDate = this.state.eventsByDate[day.getDate()];
    for (let i = 0; i < eventsByDate.length; i++) {
      if (eventsByDate[i].node.booking_status === 'INITIAL') {
        isTentative = true;
      }
    }
    return isTentative && !this.isBooked(day);
  }

  isCanceled(day) {
    let isCanceled = false;
    const eventsByDate = this.state.eventsByDate[day.getDate()];
    for (let i = 0; i < eventsByDate.length; i++) {
      if (eventsByDate[i].node.booking_status === 'CANCELED') {
        isCanceled = true;
      }
    }
    return isCanceled && !(this.isTentative(day) || this.isBooked(day));
  }

  renderDay(day) {
    const date = day.getDate();

    const eventsOnDay = this.state.eventsByDate[day.getDate()];

    if (eventsOnDay.length > 0) {
      return (
        <div>
          {this.props.showDetails &&
            <DateCell date={date} toggleAvailabilityView={this.selectDay} />}
          {!this.props.showDetails && <DateCell date={date} />}
        </div>
      );
    }
    return (
      <div>
        <DateCell date={date} />
      </div>
    );
  }

  render() {
    return (
      <DayPicker
        onDayClick={this.handleDayClick.bind(this)}
        onBlur={this.onBlur}
        selectedDays={day => DateUtils.isSameDay(day, this.props.selectedDay)}
        modifiers={{
          isTentative: this.isTentative,
          isBooked: this.isBooked,
          isCanceled: this.isCanceled
        }}
        renderDay={this.renderDay}
        onMonthChange={this.onMonthChange}
        initialMonth={this.state.visibleMonth}
        ref='daypicker'
        tabIndex={-1}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityCalendar/AvailabilityCalendar.js